import * as React from "react"
import { Box, Container, Typography, CircularProgress, Backdrop } from "@mui/material"
import { AdminRoutes } from "../../constants/routes";
import { FC, useCallback, useMemo, useState } from "react";
import { Registration, UserDto } from "../../api/dtos";
import useInvoice from "@/hooks/useInvoice";
import { useFormState } from "@ngt/forms-core";

interface InvoiceProps {
    registration: Registration
}

const Invoice = React.forwardRef(({ registration }: InvoiceProps, ref) => {
    const  {invoice, loading} = useInvoice(registration.id)

    const [displayInvoice, setDisplayInvoice] = useState<string>();

    React.useEffect(() => {
        if(!displayInvoice){
            setDisplayInvoice(invoice);
        }
    }, [invoice, loading])
    return (
        <Container
            maxWidth="lg"
        >
            {
                loading ? 
                    <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={true}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                :
                displayInvoice && (
                    <Box
                        ref={ref}
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            mt: 4
                        }}
                        dangerouslySetInnerHTML={{ __html: displayInvoice }}
                    />
                )
            }
        </Container>
    );
})

export default Invoice;

